/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotFeedStatus_org = {
    readonly id: string;
    readonly orgFlowStates: {
        readonly message?: string | null | undefined;
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly flowKey: string | null;
            readonly current: {
                readonly id: string;
                readonly state: string | null;
                readonly errorMessage: string | null;
            } | null;
        }> | undefined;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotFeedStatusUnstarted_org" | "AutopilotFeedStatusFinished_org">;
    readonly " $refType": "AutopilotFeedStatus_org";
};
export type AutopilotFeedStatus_org$data = AutopilotFeedStatus_org;
export type AutopilotFeedStatus_org$key = {
    readonly " $data"?: AutopilotFeedStatus_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotFeedStatus_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "AutopilotFeedStatus_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "flowKeys",
                        "value": [
                            "DefragRun"
                        ]
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgFlowStates",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowState",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "flowKey",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FlowStatus",
                                        "kind": "LinkedField",
                                        "name": "current",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "state",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "errorMessage",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FlowStateList",
                        "abstractKey": null
                    }
                ],
                "storageKey": "orgFlowStates(flowKeys:[\"DefragRun\"])"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "timeZone",
                        "variableName": "timeZone"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "AutopilotFeedStatusUnstarted_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotFeedStatusFinished_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '11ef315a052c92f98aa65f2c4657a011';
export default node;
